import React, { Component, Fragment } from 'react'
import styles from './Plan.styles'
import withStyles from 'react-jss'
import { Grid } from 'react-bootstrap'
import Footer from 'src/components/footer'
import TopBar from 'src/components/top_bar/TopBar'
import Titre1 from 'src/components/font/Titre1'
import Titre2 from 'src/components/font/Titre2'
import Region from './components/Region'
import { Helmet } from 'react-helmet'
import {
  categoriesOptions,
  categoriesLinkValues,
  responsiveAd,
  smBannerAd
} from 'src/config/dataConf'
import routes from 'src/routing/routes'
import ButtonLink from 'src/components/button/ButtonLink'
import { withRouter } from 'react-router-dom'
import P from 'src/components/font/P'
import {
  getCategoryTitleFromUrlParams,
  getUrlValueFromValue,
  getValueFromUrlValue
} from 'src/utils'
import Breadcrumb from 'src/components/breadcrumb/Breadcrumb'
import ListProducersByRegion from './components/ListProducersByRegion'
import responsiveComponent from '../../../hoc/responsiveComponent'
import PubContainer from '../../../components/PubContainer'

class Plan extends Component {
  render() {
    const {
      classes,
      regions,
      loading,
      isMobile,
      match: { params }
    } = this.props

    const categoryName = getValueFromUrlValue(params.category)

    return (
      <Fragment>
        <Helmet>
          <title>
            {categoryName !== categoriesOptions[0].value
              ? `${getCategoryTitleFromUrlParams(
                  params.category
                )} : ${categoryName} en vente directe producteur`
              : 'Producteurs locaux en France - Vente à la ferme - Acheter à la source'}
          </title>
          <meta
            name='description'
            content={`${
              categoryName !== categoriesOptions[0].value
                ? `${categoryName} en v`
                : 'V'
            }ente directe producteur sur Acheter à la Source. Découvrez tous les producteurs proches de chez vous et profitez de leurs produits de qualité !`}
          />
        </Helmet>

        <div className={classes.wrapper}>
          <TopBar />
          <Grid className={classes.grid}>
            <Breadcrumb
              items={[
                { name: 'Accueil', to: routes.accueil },
                {
                  name:
                    categoryName === categoriesOptions[0].value
                      ? 'Producteurs locaux'
                      : categoryName,
                  active: true
                }
              ]}
            />

            <PubContainer
              scriptPubCore={isMobile ? responsiveAd : smBannerAd}
              className={classes.ads}
            />

            <Titre1>
              {categoryName !== categoriesOptions[0].value
                ? `${categoryName} : producteurs en vente directe`
                : 'Producteurs en vente directe'}
            </Titre1>

            <P>Choisissez une catégorie puis une région ou un département</P>

            <Titre2>Catégories</Titre2>

            {categoriesOptions.map((category, i) => (
              <ButtonLink
                key={i}
                to={routes.siteMap.replace(
                  ':category',
                  i !== 0
                    ? categoriesLinkValues[i - 1].urlValue
                    : category.value
                )}
                disabled={categoryName && categoryName === category.value}
                className={
                  categoryName && categoryName === category.value
                    ? classes.categorySelected
                    : classes.liensCategories
                }
              >
                {category.label}
              </ButtonLink>
            ))}

            <Titre2>Producteurs par régions et départements</Titre2>

            <div className={classes.regionsContainer}>
              {!loading && regions ? (
                regions.map((region, i) => (
                  <Region
                    key={i}
                    nomRegion={region.nameRegion}
                    codeRegion={region.inseeRegion}
                    listeDeps={region.departments}
                    category={categoryName}
                  />
                ))
              ) : (
                <span>chargement...</span>
              )}
            </div>

            <Titre1 component='h2'>
              Aperçu des producteurs dans nos régions
            </Titre1>

            <hr className={classes.hrSeparator} />
            <ListProducersByRegion category={categoryName} />

            {categoryName !== 'all' && (
              <div className={classes.bottomContainer}>
                <ButtonLink
                  to={routes.mapProduit.replace(
                    ':category',
                    getUrlValueFromValue(categoryName)
                  )}
                  className={classes.liensCategories}
                >
                  Tous les produits
                </ButtonLink>
              </div>
            )}
          </Grid>
        </div>

        <Footer />
      </Fragment>
    )
  }
}

export default responsiveComponent(withStyles(styles)(withRouter(Plan)))
